import { Component, ElementRef, Input, OnInit, QueryList, TemplateRef, ViewChildren } from '@angular/core';
import { InAppBrowserOptions, InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { ModalController, NavParams } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AppServiceService } from 'src/app/api/app-service.service';
import { RequestService } from 'src/app/core/request.service';

import { environment } from 'src/environments/environment';

declare var config: any;

@Component({
  selector: 'app-input-select-modal',
  templateUrl: './input-select-modal-points.component.html',
  styleUrls: ['./input-select-modal-points.component.scss'],
})
export class InputSelectModalPointsComponent implements OnInit {

  @Input() content: TemplateRef<any>;
  public paymentMethods = [];
  public selectedRestaurant = null;
  public minimum_amount_points = 0;
  public maximum_amount_points = 0;
  public points_per_usd = 0;
  public amount = 0;
  public dol1 = '';
  public selected_payment = null;
  public selected_payment_special_method = null;
  public point_input_error = null;
  public update_by = 1; //how many $ should be added or removed when click plus or minu button
  public point_progressbar_width = '30%';

  public bonusList = [];
  public selectedBonus:number = 0;

  public forcedToRecharge:boolean = false;

  public predefinedPointRechargeEnabled:boolean = false;

  public specificPaymentMethodEnabledinStripe:boolean = false; //if this is true then the payment method showing style will be changed including paypal,molie if enabled then it will directed to selected specific method

  @ViewChildren('bonusContainer') bonusContainers: QueryList<ElementRef>;

  constructor(private navParams: NavParams, private requestService: RequestService, private modalCtrl: ModalController, public appService: AppServiceService, public translate: TranslateService, private iab: InAppBrowser) { }

  ngOnInit() {
    this.selectedRestaurant = this.navParams.get('selectedRestaurant');
    this.forcedToRecharge = this.navParams.get('forcedToRecharge');
    this.getPaymentMethods();
  }


  ngAfterViewInit() {
    // This lifecycle hook ensures that the view is fully initialized
    // Now you can safely access the bonusContainers
  }

  getPaymentMethods() {
    this.paymentMethods = [];
    let methods = JSON.parse(this.selectedRestaurant.payment_methods);
    for (let index = 0; index < methods.length; index++) {
      const method = methods[index];
      if (method.id == 'paypal' && method.isActive == 'true') {
        this.paymentMethods.push(method);
      }

      if (method.id == 'mollie' && method.isActive == 'true') {
        this.paymentMethods.push(method);
      }

      if (method.id == 'stripe' && method.isActive == 'true') {
        this.paymentMethods.push(method);
        // console.log('mee:',method);
        this.specificPaymentMethodEnabledinStripe = method.stripeConfigurations.is_enabled_specialAvailableMethods == "true" ? true : false;
      }

      if (method.id == 'points' && method.isActive == 'true') {
        this.minimum_amount_points = +method.pointsConfigurations.minPoints;
        this.maximum_amount_points = +method.pointsConfigurations.maxPoints;
        this.points_per_usd = +method.pointsConfigurations.valueInPoints;
        this.amount = this.minimum_amount_points / this.points_per_usd;
        this.update_by = this.points_per_usd;
        console.log('aaa:',method.pointsConfigurations);
        this.predefinedPointRechargeEnabled = method.pointsConfigurations.is_predefined_points == 'true' ? true : false;

        this.dol1 = this.formatCurrency(1);

        // if (this.appService.appObject.settings.currency_position == 'after') {
        //   this.dol1 = 1 + ' ' + this.appService.appObject.settings.currency_symbol;
        // } else {
        //   this.dol1 = this.appService.appObject.settings.currency_symbol + ' ' + 1;
        // }
        // get bonus configuration data
        if(method.pointsConfigurations && method.pointsConfigurations.bonus_points_configurations && method.pointsConfigurations.bonus_points_configurations.length){
          this.bonusList = method.pointsConfigurations.bonus_points_configurations;
          // sort bonus configuration data
          this.bonusList = this.bonusList.sort((a,b) => +a.recharge_amount - +b.recharge_amount);

        this.maximum_amount_points = this.bonusList[this.bonusList.length - 1].recharge_amount;

        }else{
          this.bonusList = [];
        }
        
      }

      if(this.predefinedPointRechargeEnabled && this.bonusList.length){
        this.selectRechargeAmount(this.bonusList[0]);
      }

    }

    if (this.paymentMethods.length > 0) {
      this.selected_payment = this.paymentMethods[0];
    }

    this.updateProgressBar();
    console.log(this.paymentMethods);
  }

  proceed() {
    this.appService.appObject.isLoading = true;

    this.appService.payPoint(this.selectedRestaurant.id, this.amount, this.selected_payment.id, this.forcedToRecharge, this.selected_payment_special_method?.method).then((response: any) => {
      if (response.status) {
        this.initPaymentMethod(response.payment_url, response.id,response);
      }
    }).catch((error) => {
      this.appService.appObject.isLoading = false;
      console.log('error : ', error);
     
      this.translate.get('key.payment_method_not_working').toPromise().then((data) => { 
        this.appService.showToast(data,'danger');
      });

    });
  }

  initPaymentMethod(url, id, response) {

    if (config.plf == 'web') { 
      
      window.location = url;
      
    } else {
      const options: InAppBrowserOptions = {
        location: 'no',
        clearcache: 'yes',
        zoom: 'yes',
        toolbar: 'yes',
        closebuttoncaption: 'close'
      };
      const browser: any = this.iab.create(url, '_blank', options);

      const pointsHistoryObject = response.point_ob;
      browser.on('loadstop').subscribe(event => {
        this.requestService.get('point/payment/status/'+pointsHistoryObject.id, {}).then(paymentDetail => {
          if(paymentDetail && paymentDetail.status && paymentDetail.historyRecord){
            let paymentStatus = paymentDetail.historyRecord.transaction_status;
            if(paymentStatus === 'success'){
              browser.close();
              // console.log('payent success');
              // this.appService.showToast('Payment Success','success');
              
              this.appService.triggerPointRechargeSuccess(paymentDetail);
              this.modalCtrl.dismiss(paymentDetail.historyRecord);
            }else if(paymentStatus === 'pending'){
              // do else here
              this.appService.showToast('Payment Pending','dark');
            }else{
              this.appService.showToast('Payment Failed','danger');
              browser.close();
              this.modalCtrl.dismiss({transaction_status:'failed'});
            }
          }
        });
      });
      // return;
      //event subscribe
      // browser.on('loadstop').subscribe(event => {
      //   //order status check
      //   this.requestService.get('point/payment/status/'+pointsHistoryObject.id, {}).then(paymentStatus => {
      //     if (paymentStatus.status && (paymentStatus.data.status === "success")) {
      //       setTimeout(() => {
      //         //payment done
      //         browser.close();
      //         this.translate.get('key.payment_succeess').toPromise().then((response) => {
      //           this.appService.showAlert('success', '', response);
      //         });
      //       }, 3000);
      //     } else if (paymentStatus.status && paymentStatus.data.status === "cancelled") {
      //       setTimeout(() => {
      //         //payment cancelled
      //         browser.close();
      //         //err
      //         this.translate.get('key.payment_faild_msg').toPromise().then((response) => {
      //           this.appService.showAlert('error', '', response);
      //         });
      //       }, 3000);
      //     } else {
      //       //payment cancelled
      //       const navUrl = event.url;
      //       if (navUrl.includes('return')) {
      //         setTimeout(() => {
      //           browser.close();
      //           //err
      //           this.translate.get('key.payment_faild_msg').toPromise().then((response) => {
      //             this.appService.showAlert('error', '', response);
      //           });
      //         }, 3000);
      //       }
      //     }

      //     setTimeout(() => {
      //       this.appService.showAlert('success','some',JSON.stringify(paymentStatus),false);
      //     }, 5000);
      //   });
      // });
    } 

  }

  formatCurrency(amount){ 
    if(this.appService.appObject.settings && this.appService.appObject.settings.currency_symbol){
      if (this.appService.appObject.settings.currency_position == 'after') {
        return amount + ' ' + this.appService.appObject.settings.currency_symbol;
      } else {
        return this.appService.appObject.settings.currency_symbol + ' ' + amount;
      }
    }else{
      return amount;
    }
  }

  changeAmount(type: string, event = null): boolean {
    if(this.predefinedPointRechargeEnabled){
        return false;
    }
    let amount = '0';
    // mona bijjak da kale ashan
    // that's why i put this code, check comit changes
    if(event && event.target && event.target.value){
      amount = event.target.value;
    }
    
    this.point_input_error = null;

    if (type == 'minus' && this.checkMinumumAmountOfPoints(this.amount - 1)) {
      this.amount = this.amount - 1;
      this.updateProgressBar();
    }

    if (type == 'plus' && this.checkMaximumAmountOfPoints(this.amount + 1)) {
      this.amount = this.amount + 1;
      this.updateProgressBar();
    }

    if (type == 'change') {
      if (this.isValidPriceNumber(amount) && this.checkMaximumAmountOfPoints(parseFloat(amount)) && this.checkMinumumAmountOfPoints(parseFloat(amount))) {
        this.amount = parseFloat(amount);
        this.updateProgressBar();
      }

      if (!this.isValidPriceNumber(amount)) {
        if (amount == "") {
          this.translate.get('key.amount_field_cannot_be_empty').toPromise().then((data) => {
            this.point_input_error = data;
          });
        } else {
          this.translate.get('key.entered_value_is_not_valid').toPromise().then((data) => {
            this.point_input_error = data;
          });
        }
      } else {
        if (!this.checkMaximumAmountOfPoints(parseFloat(amount))) {
          //this.amount = this.maximum_amount_points/this.points_per_usd;
          //this.point_input_error = 'Maximum Amout is ' + this.maximum_amount_points / this.points_per_usd + ' Euroes (' + this.maximum_amount_points + ' Points)';
          this.translate.get('key.maximum_amount_is_exceeded').toPromise().then((data) => {
            this.point_input_error = data + ' : ' + this.maximum_amount_points;
          });
        }

        if (!this.checkMinumumAmountOfPoints(parseFloat(amount))) {
          //this.amount = this.minimum_amount_points/this.points_per_usd;
          //this.point_input_error = 'Minimum Amout is ' + this.minimum_amount_points / this.points_per_usd + ' Euroes (' + this.minimum_amount_points + ' Points)';
          this.translate.get('key.should_be_more_than_or_equal_to_minimum_amount').toPromise().then((data) => {
            this.point_input_error = data + ' : ' + this.minimum_amount_points;
          });
        }
      }
    }

  }

  checkMaximumAmountOfPoints(amount): boolean {
    if ((amount * this.points_per_usd) <= this.maximum_amount_points) {
      return true
    } else {
      return false;
    }

  }

  checkMinumumAmountOfPoints(amount): boolean {

    if ((amount * this.points_per_usd) >= this.minimum_amount_points) {
      return true
    } else {
      return false;
    }

  }

  updateProgressBar() {
    const percentage = ((this.amount * this.points_per_usd) / this.maximum_amount_points) * 100;

    const adjustedPercentage = Math.log(percentage + 1) / Math.log(101) * 100;

    this.point_progressbar_width = `${adjustedPercentage}%`;

    let graterThanBonusList = this.bonusList.filter((bonus,index) => this.amount >= +bonus.recharge_amount);
    this.selectedBonus = graterThanBonusList[graterThanBonusList.length - 1];

    this.centerActiveDiv();

  }


  isValidPriceNumber(input: string): boolean {
    // Regular expression to match a number (with optional two decimal points)
    const priceRegex: RegExp = /^\d+(\.\d{1,2})?$/;
    return priceRegex.test(input);
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data

    this.modalCtrl.dismiss({
      'dismissed': true
    });
  }



 


  centerActiveDiv() {
    // Wait for the view to be initialized before finding the active element
    setTimeout(() => {
      const activeDiv = this.bonusContainers.toArray().find(div => div.nativeElement.classList.contains('active'));
      if (activeDiv) {
        const container = document.querySelector('.point-bonus');
        if (container) {
          const containerWidth = container.clientWidth;
          const activeDivOffset = activeDiv.nativeElement.offsetLeft;
          const activeDivWidth = activeDiv.nativeElement.clientWidth;

          // Calculate the scroll position to center the active div
          const scrollPosition = (activeDivOffset - (containerWidth / 2) + (activeDivWidth / 2))-40;
          container.scrollLeft = scrollPosition;

          container.scroll({
            left: scrollPosition,
            behavior: 'smooth'
          });

        }
      }
    });
  }

  updateClass(){
    let selectedBonus = this.bonusList.find((bonus,index) => {
      console.log('bonuus : ' , bonus, ' | ' , index);
      
    })
  }

  selectRechargeAmount(i){ 
    this.amount = parseFloat(i.recharge_amount);
    this.updateProgressBar();
  }

  selectStripeSpecialMethod(method, specialMethod){
      this.selected_payment = method;
      this.selected_payment_special_method = specialMethod;
  }
  getPaymentImage(poption){
    return environment.API_URL + 'payment-logo/get/' + poption.method;
  }
}
